import {
  Box,
  Button,
  ButtonIcon,
  Flex,
  Text,
  TextField,
  Tooltip,
  TooltipTrigger,
} from '@backstage/ui';
import { RiDeleteBinFill } from '@remixicon/react';
import { useLabelsContext } from '../Providers';

interface ModernLabelsInputProps {
  isInitialInput?: boolean;
}

export const ModernLabelsInput = (props: ModernLabelsInputProps) => {
  const { isInitialInput = true } = props;

  const {
    labels,
    isKeyInvalidFormat,
    isDuplicated,
    isValueEmpty,
    updateLabelKey,
    updateLabelValue,
    addLabel,
    deleteLabel,
  } = useLabelsContext();

  return (
    <Flex direction="column" gap="2">
      <Text as="h3" variant="title-small" weight="bold">
        Labels
      </Text>

      <Flex direction="column" gap="2">
        {labels.map(pair => (
          <Flex key={pair.id} gap="2" align="end">
            <Box style={{ flex: 1 }}>
              <TextField
                name={`label-key-${pair.id}`}
                label="Key"
                type="text"
                value={pair.key}
                onChange={value => updateLabelKey(pair.id, value)}
              />
            </Box>

            <Box style={{ flex: 1 }}>
              <TextField
                name={`label-value-${pair.id}`}
                label="Value"
                type="text"
                value={pair.value}
                onChange={value => updateLabelValue(pair.id, value)}
              />
            </Box>

            <TooltipTrigger delay={100}>
              <ButtonIcon
                icon={<RiDeleteBinFill />}
                variant="tertiary"
                size="small"
                onClick={() => deleteLabel(pair.id)}
                aria-label="Delete label"
                excludeFromTabOrder
              />
              <Tooltip placement="bottom">Delete</Tooltip>
            </TooltipTrigger>
          </Flex>
        ))}
      </Flex>

      {!isInitialInput && (
        <Flex direction="column" gap="1">
          {isValueEmpty && (
            <Text variant="body-small" style={{ color: 'red' }}>
              Some label&apos;s value is empty!
            </Text>
          )}
          {isDuplicated && (
            <Text variant="body-small" style={{ color: 'red' }}>
              Some label&apos;s key is duplicated!
            </Text>
          )}
        </Flex>
      )}

      <Text
        variant="body-small"
        style={{
          color: isKeyInvalidFormat && !isInitialInput ? 'red' : '#6d6d6d',
        }}
      >
        Label&apos;s key must consist of letters and/or numbers separated by
        &apos;-&apos;, &apos;_&apos; or &apos;.&apos; and its length must be
        less than 63.
      </Text>

      <Flex justify="end">
        <Button variant="tertiary" type="button" onPress={() => addLabel()}>
          + Add Label
        </Button>
      </Flex>
    </Flex>
  );
};
